import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import cloneDeep from 'lodash/cloneDeep';
import ReduxFormField from '../../common/forms/ReduxFormsField';

const validate = values => {
  const errors = {};
  const { name, description } = values;

  if (!name || !name.trim()) {
    errors.name = ['Name is required'];
  } else if (name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  if (!description || !description.trim()) {
    errors.description = ['Description is required'];
  } else if (description.trim().length > 255) {
    errors.description = ['Description cannot be longer than 255 characters'];
  }

  return errors;
};

class ChapterEditForm extends Component {
  static propTypes = {
    ...formPropTypes,
    onCancel: PropTypes.func.isRequired,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);
    submitValues.description = submitValues.description.trim();
    submitValues.name = submitValues.name.trim();

    return this.props.onSubmit(submitValues);
  };

  renderBadgeOptionsItem(badge, isCurrentlyAssigned) {
    return (
      <option key={badge.get('id')} value={badge.get('id')}>
        {`${badge.get('name')}${isCurrentlyAssigned ? ' (Currently Assigned)' : ''}`}
      </option>
    );
  }

  renderBadgeOptions() {
    const { badges, chapter } = this.props;
    const options = [
      <option key="default" value="">
        None
      </option>,
    ];
    if (chapter.get('badge_id')) {
      options.unshift(this.renderBadgeOptionsItem(chapter.get('badge'), true));
    }
    badges.forEach(
      badge => chapter.get('badge_id') !== badge.get('id') && options.push(this.renderBadgeOptionsItem(badge))
    );
    return options;
  }

  render() {
    const { handleSubmit, onCancel, submitting } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="name" component={ReduxFormField} label="Chapter Name" required={true}>
            <input type="text" />
          </Field>
          <Field name="description" component={ReduxFormField} label="Chapter Description" required={true}>
            <input type="text" />
          </Field>
          <Field name="badge_id" component={ReduxFormField} label="Badge" required>
            <select>{this.renderBadgeOptions()}</select>
          </Field>
          <div className="admin-paper__edit-content__button-row flex-end">
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'chapterEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(ChapterEditForm);



// WEBPACK FOOTER //
// ./src/courses/chapters/ChapterEditForm.js